import { CollapsibleCard, DocumentLineIcon, RichTextRenderer, Space } from 'ui';

type P = {
  htmlContent?: null | string;
};

const Description = ({ htmlContent }: P) => {
  if (!htmlContent) {
    return null;
  }

  return (
    <Space align="start" className="calendar-event-description">
      <DocumentLineIcon />
      <CollapsibleCard card={{ marginBottom: false, shrinked: true }}>
        <RichTextRenderer data={htmlContent} marginTop={false} />
      </CollapsibleCard>
    </Space>
  );
};

export default Description;
